import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import API_URL from '@/config/api';
import { formatApiError } from '@/utils/apiError';
import { InstallerLeadFormView } from '@/components/embed/InstallerLeadFormView';

export default function EmbedInstallerLeadForm() {
  const { token } = useParams();
  const [config, setConfig] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API_URL}/api/public/lead-form/${token}`)
      .then(async (r) => { if (!r.ok) throw new Error('This form is no longer available.'); setConfig(await r.json()); })
      .catch((e) => setError(e.message));
  }, [token]);

  const submit = async (form) => {
    const res = await fetch(`${API_URL}/api/public/lead-form/${token}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(formatApiError(data) || 'Submission failed — please try again.');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'transparent', padding: '12px 10px' }} data-testid="embed-installer-lead-form-root">
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        {error && <div data-testid="embed-installer-lead-form-error" style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 24, textAlign: 'center', color: '#666', fontFamily: 'sans-serif' }}>{error}</div>}
        {config && <InstallerLeadFormView config={config} onSubmit={submit} />}
      </div>
    </div>
  );
}
